export default defineAppConfig({
  ui: {
    primary: 'blue',
    gray: 'slate',
    button: {
      defaultVariants: {
        size: 'md',
        color: 'primary',
        variant: 'solid',
      },
      slots: {
        base: 'font-semibold rounded-lg',
      },
      // border-2 only on standalone variants; link/ghost (used inside inputs,
      // e.g. the search clear button and InputNumber +/- controls) stay borderless
      // so they don't overflow the field height.
      compoundVariants: [
        { variant: 'solid', class: 'border-2 border-transparent' },
        { color: 'primary', variant: 'solid', class: 'text-[var(--ui-text-on-primary)]' },
        { variant: 'outline', class: 'border-2' },
        { variant: 'subtle', class: 'border-2' },
        { variant: 'soft', class: 'border-2 border-transparent' },
      ],
    },
    card: {
      slots: {
        root: 'rounded-xl',
      },
    },
    badge: {
      defaultVariants: {
        variant: 'soft',
        size: 'md',
      },
      variants: {
        size: {
          xs: {
            base: 'text-[11px]/4 px-1.5 py-0.5 gap-1 rounded-md',
            leadingIcon: 'size-3',
            leadingAvatarSize: '3xs',
            trailingIcon: 'size-3',
          },
          sm: {
            base: 'text-xs px-2 py-0.5 gap-1 rounded-md',
            leadingIcon: 'size-3.5',
            leadingAvatarSize: '3xs',
            trailingIcon: 'size-3.5',
          },
        },
      },
    },
    formField: {
      slots: {
        root: 'w-full',
        wrapper: 'w-full',
        container: 'w-full',
      },
    },
    input: {
      slots: {
        root: 'relative flex w-full items-center',
      },
    },
    textarea: {
      slots: {
        root: 'relative flex w-full',
      },
    },
    select: {
      slots: {
        base: 'w-full',
      },
    },
    selectMenu: {
      slots: {
        base: 'w-full',
      },
    },
  },
  site: {
    /** Generic fallbacks only — real values come from shop settings in DB. */
    name: 'Magazin',
    /** Empty on purpose: never show a demo/tenant logo when settings are missing. */
    logo: '',
    phone: '',
    email: '',
    address: '',
  },
})
